var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92188 1.51562H3.8125C3.87266 1.51562 3.92188 1.46641 3.92188 1.40625V1.51562H8.07812V1.40625C8.07812 1.46641 8.12734 1.51562 8.1875 1.51562H8.07812V2.5H9.0625V1.40625C9.0625 0.923633 8.67012 0.53125 8.1875 0.53125H3.8125C3.32988 0.53125 2.9375 0.923633 2.9375 1.40625V2.5H3.92188V1.51562ZM10.8125 2.5H1.1875C0.945508 2.5 0.75 2.69551 0.75 2.9375V3.375C0.75 3.43516 0.799219 3.48438 0.859375 3.48438H1.68516L2.02285 10.6348C2.04473 11.101 2.43027 11.4688 2.89648 11.4688H9.10352C9.57109 11.4688 9.95527 11.1023 9.97715 10.6348L10.3148 3.48438H11.1406C11.2008 3.48438 11.25 3.43516 11.25 3.375V2.9375C11.25 2.69551 11.0545 2.5 10.8125 2.5ZM8.99824 10.4844H3.00176L2.6709 3.48438H9.3291L8.99824 10.4844Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/delete-user.e9b7ccb543eacf1048f695a808bed789.svg";
export { ForwardRef as ReactComponent };